module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Chester Patterson-3425dbce8cfa04122a9673d18f698b06.jpg";